<!-- 銀行口座情報登録 -->
<template>
  <div class="l-modal__bg" v-if="loading"></div>

  <div class="bank">
    <div v-show="loading" class="loading">
      <img src="../assets/loading.gif" />
    </div>
    <!-- <header class="header">
      <img src="../assets/omi-logo.svg" />
    </header> -->
    <!-- <div class="title">
        <p v-if="!isUser">事前登録受付</p>
        <p v-else>ユーザー情報更新</p>
      </div> -->
    <Form
      class="form"
      :validationSchema="validationSchema"
      v-slot="{ meta: { valid } }"
      v-if="!updated"
    >
      <div style="padding-bottom: 500px">
        <div style="padding-top: 40px">
          <label>種別</label>
          <div class="radio-button-area">
            <input
              type="radio"
              id="0"
              name="accountType"
              value="0"
              v-model="accountType"
              :disabled="loading || deleting"
            />
            <label for="0">個人</label>
            <input
              type="radio"
              id="1"
              name="accountType"
              value="1"
              v-model="accountType"
              :disabled="loading || deleting"
            />
            <label for="1">法人</label>
            <div></div>
          </div>
        </div>
        <div style="padding-top: 40px">
          <label>銀行名</label>
          <div class="text-area">
            <Field
              type="text"
              v-model="bank"
              name="bank"
              placeholder="〇〇銀行"
              class="text-field"
              :disabled="loading || deleting"
              tabindex="1"
            />
            <div>
              <ErrorMessage name="bank" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>口座種別</label>
          <div class="radio-button-area">
            <input
              type="radio"
              id="0"
              name="bankAccountType"
              value="0"
              v-model="bankAccountType"
              :disabled="loading || deleting"
            />
            <label for="0">普通</label>

            <input
              type="radio"
              id="1"
              name="bankAccountType"
              value="1"
              v-model="bankAccountType"
              :disabled="loading || deleting"
            />
            <label for="1">当座</label>
            <div></div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>支店名</label>
          <div class="text-area">
            <Field
              type="text"
              v-model="branch"
              name="branch"
              placeholder="支店名"
              class="text-field"
              :disabled="loading || deleting"
              tabindex="3"
            />
            <div>
              <ErrorMessage name="branch" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>口座番号</label>
          <div class="text-area">
            <Field
              type="text"
              inputmode="numeric"
              v-model="bankAccountNumber"
              name="bankAccountNumber"
              placeholder="1234567"
              class="text-field"
              :disabled="loading || deleting"
              tabindex="4"
            />
            <div>
              <p style="font-size: 12px; color: #2c3e50">
                ※口座番号が7桁に満たない場合は口座番号の前に「0」を加えて入力してください
              </p>
              <ErrorMessage name="bankAccountNumber" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>口座名義</label>
          <div class="text-area">
            <Field
              type="text"
              v-model="bankAccountName"
              name="bankAccountName"
              placeholder="ヤマダ タロウ"
              class="text-field"
              :disabled="loading || deleting"
              tabindex="5"
            />
            <div>
              <ErrorMessage name="bankAccountName" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>
      </div>
      <div class="button-area">
        <common-button
          :data="{
            status: !valid || loading ? 2 : 0,
            button: deleting ? `登録中` : userInfoStore.isRegistFromProjectDetail.show && !userInfoStore.userSnsInfo.find((v) => v.media_type == userInfoStore.isRegistFromProjectDetail.mediaType) ? `次へ` : `登録`,
          }"
          @click="valid && !loading && !deleting ? onSubmit() : ''"
          v-if="!userInfoStore.bankInfo.id"
        ></common-button>
        <common-button
          :data="{
            status: !valid || loading ? 2 : 0,
            button: loading ? `更新中` : `更新`,
          }"
          @click="valid && !loading && !deleting ? onSubmit() : ''"
          :disabled="!valid || loading"
          style="margin-bottom: 20px"
          v-else
        ></common-button>

        <common-button
          :data="{
            status: 3,
            button: deleting ? `削除中` : `削除`,
          }"
          @click="!loading && !deleting ? deleteBanckAccount() : ''"
          v-if="userInfoStore.bankInfo.bank_account_name"
        ></common-button>
      </div>
    </Form>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { useRouter } from "vue-router";
import { Field, Form, ErrorMessage } from "vee-validate";
import CommonButton from "./CommonButton.vue";

import * as yup from "yup";
import { bankInfoRequest } from "../types/apiRequest";
const bank = ref("");
const bankAccountType = ref(0);
const accountType = ref(0)
const router = useRouter();
const branch = ref("");
const bankAccountNumber = ref("");
const bankAccountName = ref("");
const updated = ref(false);

const userInfoStore = UserInfoStore();
const loading = ref(false);
const deleting = ref(false);
const validationSchema = ref(
  yup.object().shape({
    bank: yup
      .string()
      .trim()
      .required("銀行名は必須です")
      .min(1)
      .label("銀行名"),
    branch: yup
      .string()
      .trim()
      .required("支店名は必須です")
      .min(1)
      .label("支店名"),
    bankAccountNumber: yup
      .string()
      .required("口座番号は必須です")
      .length(7, "口座番号は半角数字7桁で入力してください")
      .matches(/^[0-9]+$/, "口座番号は半角数字7桁で入力してください")
      .label("口座番号"),
    bankAccountName: yup
      .string()
      .required("口座名義は必須です")
      .matches(/^[ｦ-ﾟ ァ-ヶー （） a-zA-Z \s]*$/, "口座名義はカタカナ、アルファベットで入力してください")
      .label("口座名義"),
  })
);
onMounted(async () => {
  if (!userInfoStore.bankInfo.id) {
    await userInfoStore.getBankInfo();
    if (!userInfoStore.bankInfo.id) {
      document.title = "振込先口座情報登録";
      return;
    }
  }
  // 登録済の情報を初期値で入れる
  setInitialData();
});

const setInitialData = () => {
  document.title = "振込先口座情報更新";
  bank.value = userInfoStore.bankInfo.bank_name;
  bankAccountType.value = userInfoStore.bankInfo.bank_type;
  accountType.value = userInfoStore.bankInfo.account_type;
  branch.value = userInfoStore.bankInfo.bank_branch;
  bankAccountNumber.value = userInfoStore.bankInfo.bank_code;
  bankAccountName.value = userInfoStore.bankInfo.bank_account_name;
};

// 登録処理
const onSubmit = async () => {
  // 複数回リクエストが飛ばないようにする
  if (loading.value) return;
  loading.value = true;
  const request: bankInfoRequest = {
    bank_account_name: bankAccountName.value, //口座名義
    bank_branch: branch.value, //支店名
    bank_code: bankAccountNumber.value || "", //口座番号
    bank_name: bank.value, //銀行名
    bank_type: bankAccountType.value, //口座種別 普通:0, 当座: 1
    account_type: accountType.value // 種別 個人:0, 法人: 1
  };

  await userInfoStore.updateBankInfo(request).then((v) => {
    if (v) {
      updated.value = true;
      if (userInfoStore.isRegistFromProjectDetail.show) {
        if (!userInfoStore.userSnsInfo.length || !userInfoStore.userSnsInfo.find((v) => v.media_type == userInfoStore.isRegistFromProjectDetail.mediaType)) {
          router.replace("/sns-accounts");
        } else if (userInfoStore.addressInfo.id < 0) {
          router.replace("/address");
        } else {
          userInfoStore.setIsRegistFromProjectDetail({ show: false, title: "", mediaType: -1 });
          router.replace("/project-detail");
        }
      } else {
        router.go(-1);
      }
    }
    loading.value = false;
  });
};
async function deleteBanckAccount() {
  deleting.value = true;
  await userInfoStore.deleteBankInfo().then((v) => {
    if (v) {
      updated.value = true;
      setTimeout(() => router.go(-2), 1000);
    }

    deleting.value = false;
  });
}
</script>
<style lang="scss" scoped>
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";

.bank {
  // touch-action: none;
  overflow: auto;
  width: 100%;
  max-width: 480px;
  height: 100%;
  max-height: 810px;
  scrollbar-gutter: stable;
}
.bank::-webkit-scrollbar {
  display: none;
}
.header {
  text-align: center;
  width: 100%;
}

label {
  font-size: $FONT_SIZE_M;
}
.form {
  width: 100%;
  max-width: 307px;
  margin: 0 auto;
  // font-family: $font-family-hiragino-gothic-pron;
  // text-align: center;
}
.error {
  color: red;
  text-align: center;
  margin: 0;
}
.title {
  margin-top: 40px;
  text-align: center;
  // font-family: $font-family-hiragino-gothic-pron;
  font-style: normal;
  font-weight: 600;
  font-size: $FONT_SIZE_L;
  line-height: 24px;
  height: 60px;
  width: 100%;
  max-width: 480px;
  background-color: rgba(8, 110, 182, 0.04);
  > p {
    margin: 0;
    padding-top: 18px;
  }
}
.button-area {
  width: 100%;
  max-width: 317px;
  margin: 0 auto;
  text-align: center;
  display: block;
  position: fixed;
  bottom: 80px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
  padding-top: 10px;
  // width: 200px;
  margin: 0 auto;
}
.loading {
  display: flex;
  position: absolute;
  justify-content: center;
  top: 50%;
  z-index: 9999;
  img {
    width: 10%;
    height: 10%;
  }
}
.text-area {
  width: 307px;
  margin: 0 auto;
  padding-top: 8px;
}
.text-field {
  width: 307px;
  height: 48px;
  border: 1px solid #777777;
  border-radius: 2px;
  background-color: $white;
  padding: 0 0 0 8px;
  font-size: $FONT_SIZE_M;
}
.radio-button-area {
  width: 307px;
  // margin: 0 auto;
  padding-top: 22px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
label {
  padding-right: 32px;
  padding-left: 8px;
}
input[type="radio"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input[type="radio"] {
  position: relative;
  width: 21px;
  height: 21px;
  border: 1px solid #999999;
  border-radius: 50%;
  vertical-align: -2px;
}

input[type="radio"]:checked:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #999999;
  border: 1px solid #999999;
  content: "";
  // content: url("../assets/radio.svg");
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
}
</style>
